<div class="stepper-container text-center">
  <div class="stepper d-flex justify-content-center align-items-center gap-1">
    <ng-container *ngFor="let step of steps">
      <span
        class="step cursor-pointer px-3 py-1 text-gray-500 font-medium"
          [class.text-primary]="step.active"
          [class.font-bold]="step.active"
          (click)="selectStep(step.id)">{{ step.name }}</span>
      <span *ngIf="step.id !== 3"
            class="step cursor-pointer px-3 py-1 text-gray-500 font-medium"> &gt; </span>
    </ng-container>
  </div>
</div>
